import { useEffect, useState } from 'react';
import { WORKFLOW_MAP } from '@/constants';
import { getSubdomain } from '@/utils/getSubdomain';

export interface WorkflowData {
  workflowEnabled: boolean;
  domain: string | null;
  templateJson: unknown;
  reqUrl: string | null;
  error: Error | null;
  loading: boolean;
}

export const useWorkflow = () => {
  const [domain, setDomain] = useState<string | null>(null);
  const [templateJson, setTemplateJson] = useState<unknown>({});
  const [reqUrl, setReqUrl] = useState<string | null>(null);
  const [workflowEnabled, setWorkflowEnabled] = useState(false);
  const [error, setError] = useState<Error | null>(null);
  const [loading, setLoading] = useState(true);

  const workflowPath = window.location.pathname.split('/')[1];

  useEffect(() => {
    setDomain(getSubdomain);
  }, []);

  useEffect(() => {
    // the url in this function will have to be swapped to hosted config path when ready
    const request = async () => {
      if (domain && WORKFLOW_MAP[workflowPath]) {
        const url = `/static/workflowmock/${domain}/${workflowPath}/`;
        setReqUrl(url);
        try {
          const response = await fetch(`${url}config.json`);
          const result = await response.json();
          setTemplateJson(result);
        } catch (e) {
          setTemplateJson({});
          setError(e);
        }
        setWorkflowEnabled(true);
      }
      setLoading(false);
    };
    request();
  }, [domain, workflowPath]);

  return {
    domain,
    templateJson,
    reqUrl,
    workflowEnabled,
    error,
    loading,
  };
};
